import useMeetingReport from "@app/analytics/MeetingReport/hooks/useMeetingReport";
import useSingleSessionInfoQuery from "@app/common/hooks/useSingleSessionInfoQuery";
import * as SessionUtils from "@app/common/utils/sessionUtils";

const useMeetingDetails = (sessionId: string) => {
  const {
    meetingStartTime,
    isLoading: meetingReportIsLoading,
    isError: meetingReportIsError,
  } = useMeetingReport();

  const {
    data: sessionInfo,
    isLoading: meetingSummaryIsLoading,
    isError: meetingSummaryIsError,
  } = useSingleSessionInfoQuery(sessionId!);

  const meetingDetails = {
    title: sessionInfo?.title ?? "",
    callDate: meetingStartTime,
    startTime: meetingStartTime,
    isNotetakerReport: SessionUtils.isNotetaker(sessionInfo),
  };

  return {
    data: meetingDetails,
    isInitialLoading: meetingReportIsLoading || meetingSummaryIsLoading,
    isError: meetingSummaryIsError || meetingReportIsError,
  };
};

export default useMeetingDetails;
